import { QueryClient } from "@tanstack/react-query";

/**
 * Defaults tuned for a phone carried around an aviary: the network drops constantly,
 * so cached data stays usable rather than being refetched on every window focus, and
 * writes are not retried by the client — the API's idempotency keys make a retry safe,
 * but a silent one hides a genuine failure from the breeder.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 30 * 60_000,
        refetchOnWindowFocus: false,
        retry: 2,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
